import clsx from "clsx";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigationContext } from "web/react/components/navigation/navigation.context";
import { closeAssistedSearch } from "web/redux/ducks/app-header-bar";
import { setSelectedGender } from "web/redux/ducks/main-navigation";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import { AppHeaderBarGenderSerializer } from "web/types/serializers";
import styles from "./header-genders.module.css";

function extractSelectedGender(state: ReduxStoreState): string {
    return state.mainNavigationReducer.selectedGender;
}

interface HeaderGendersProps {
    genders: AppHeaderBarGenderSerializer[];
}

function HeaderGenders({ genders }: HeaderGendersProps): React.ReactElement {
    const activeSelected = useSelector(extractSelectedGender);
    const dispatch = useDispatch();

    const { showMenu, setShowMenu, handleMenuOpenedAnalytics } = useNavigationContext();

    // Update the redux state with the navbar gender if it's not set
    useEffect(() => {
        if (!activeSelected) {
            genders.forEach((gender) => {
                if (gender.selected) {
                    dispatch(setSelectedGender(gender.value));
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onGenderClick(event: React.SyntheticEvent<HTMLAnchorElement>, gender = "women"): void {
        event.preventDefault();
        const switchGender = gender !== activeSelected;

        if (!switchGender && showMenu) {
            setShowMenu(null);
            handleMenuOpenedAnalytics("opened", gender);
        } else {
            dispatch(closeAssistedSearch());
            dispatch(setSelectedGender(gender));
            setShowMenu("mobile");
            handleMenuOpenedAnalytics("closed", gender);
        }
    }

    return (
        <span className={clsx(styles.genders, "hidden-tablet")}>
            {genders.map((gender) => (
                <a
                    key={gender.value}
                    href={`${gender.gender_home_page}#category-navigation`}
                    className={clsx(styles.gender, {
                        [styles.genderSelected]: activeSelected
                            ? activeSelected === gender.value
                            : gender.selected,
                    })}
                    onClick={(event) => onGenderClick(event, gender.value)}
                >
                    <span>
                        {gender.value === "women" && gettext("header.gender.women").toUpperCase()}
                        {gender.value === "men" && gettext("header.gender.men").toUpperCase()}
                    </span>
                </a>
            ))}
        </span>
    );
}

export default HeaderGenders;
